import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
axios.defaults.baseURL = 'https://chatportal.pranathiss.com/qxbox/';
if (window.location.host.includes("app.avatarchatbots.ai")){
    axios.defaults.baseURL = 'https://app.avatarchatbots.ai/qxbox/';
}else if(window.location.host.includes("chatportal.pranathiss.com")){
    axios.defaults.baseURL = 'https://chatportal.pranathiss.com/qxbox/';   
} 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
